import { render, staticRenderFns } from "./abbreviation.vue?vue&type=template&id=2ae7149e&scoped=true"
import script from "./abbreviation.vue?vue&type=script&lang=js"
export * from "./abbreviation.vue?vue&type=script&lang=js"
import style0 from "./abbreviation.vue?vue&type=style&index=0&id=2ae7149e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7149e",
  null
  
)

export default component.exports